import cfg from './generated/brand-config'
import { objectKeys } from '@jotta/types/TypeUtils'

export const config = cfg
export const brandKeys = objectKeys(config)

type ConfigType = typeof config
export type BrandKey = keyof ConfigType
export type BrandConfig = ConfigType[BrandKey]
export type BrandName = BrandConfig['name']
export type BrandAlias = BrandConfig['alias']

export function isBrandKey(value: unknown): value is BrandKey {
  return Boolean(config[value as BrandKey])
}
export function getBrandAlias(value: BrandKey): BrandAlias {
  return config[value].alias
}
export function getBrandName(value: BrandKey): BrandName {
  return config[value].name
}
